import { render } from "./ContextMenuComponent.vue?vue&type=template&id=0d3ad0d0&scoped=true&ts=true"
import script from "./ContextMenuComponent.vue?vue&type=script&lang=ts"
export * from "./ContextMenuComponent.vue?vue&type=script&lang=ts"

import "./ContextMenuComponent.vue?vue&type=style&index=0&id=0d3ad0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3ad0d0"]])

export default __exports__